import { WxShape } from './wx-shape';
import { Vector3 } from 'three';
import { WxRectangleVO } from '@article/model/vo/wx-article.vo';
import { CommonConstants } from '@3d-scene/constants/common-constants';

export class WxRectangle extends WxShape {
  public length: number;
  public width: number;

  public constructor(element: WxRectangleVO) {
    super();
    this.length = element.length > 0 ? element.length * CommonConstants.COMMON_SCALE : 10;
    this.width = element.width > 0 ? element.width * CommonConstants.COMMON_SCALE : 10;
    this.closed = true;
  }

  public getPoints(isConnection: boolean = false): Vector3[] {
    if (isConnection) {
      return [
        new Vector3(-0.5 * this.width, -0.5 * this.length, 0),
        new Vector3(0.5 * this.width, -0.5 * this.length, 0),
        new Vector3(0.5 * this.width, 0.5 * this.length, 0),
        new Vector3(-0.5 * this.width, 0.5 * this.length, 0),
      ];
    }
    return [
      new Vector3(-0.5 * this.width, 0, -0.5 * this.length),
      new Vector3(0.5 * this.width, 0, -0.5 * this.length),
      new Vector3(0.5 * this.width, 0, 0.5 * this.length),
      new Vector3(-0.5 * this.width, 0, 0.5 * this.length),
    ];
  }
}
